/* eslint-disable */
import React, { useState } from "react";
import ImageUploading from "react-images-uploading";
import ImageCard from "../Components/ImagesCard";
// import ImageDecriptionModal from "../Components/ImageDecriptionModal";
import ModalImage from "../Components/modal/ModalImage";
const Images = (({ images, setImages, commentSectionRef }) => {
    const maxNumber = 70;
    const [featuredIndex, setFeaturedIndex] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [description, setDescription] = useState("");
    const [isModalOpenCustom, setIsModalOpenCustom] = useState(false);

    const openModalCustom = () => setIsModalOpenCustom(true);
    const closeModalCustom = () => setIsModalOpenCustom(false);


    const onChange = (imageList) => {
        setImages(imageList);
    };
    const moveImage = (fromIndex, toIndex) => {
        const updatedImages = [...images];
        const [movedImage] = updatedImages.splice(fromIndex, 1);
        updatedImages.splice(toIndex, 0, movedImage);
        setImages(updatedImages);
    };
    const handleDelete = (index) => {
        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
    };
    const handleStarClick = (index) => {
        if (index === 0) return;
        moveImage(index, 0);
        setFeaturedIndex(0);
    };
    const handleDescriptionClick = (image, index) => {
        setSelectedImage({ ...image, index });
        setDescription(image.description || "");
        setIsModalOpen(true);
        window.scrollTo({ top: 1500, behavior: "smooth" })
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
        if (commentSectionRef.current) {
            console.log(commentSectionRef.current, "reference");
        }
    };

    const saveDescription = () => {
        if (selectedImage) {
            const updatedImages = [...images];
            updatedImages[selectedImage.index] = {
                ...selectedImage,
                description: description,
            };
            setImages(updatedImages);
        }
        closeModal();
    };
    return (
        <>
            <div className="col-md-12">
                <ImageUploading
                    multiple
                    value={images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                    acceptType={["jpg", "jpeg", "png", "webp"]}
                >
                    {({
                        imageList,
                        onImageUpload,
                        isDragging,
                        dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                            <div
                                className="fu-text"
                                style={isDragging ? { color: "red" } : null}
                                onClick={onImageUpload}
                                {...dragProps}
                            >
                                <div className="add-list-media-wrap">
                                    <div className="listsearch-input-item fl-wrap">
                                        <div className="fuzone">
                                            <form>
                                                <div className="fu-text">
                                                    <span>
                                                        <i className="fal fa-images" /> PLEASE BE PATIENT WHILE
                                                        YOUR PHOTOS UPLOAD :)<br />
                                                        Drag and drop the images to customize the gallery
                                                        order.<br />
                                                        Click on the star icon to set the featured image.<br />
                                                        <span>(Minimum size 1440 x 900 px)</span>
                                                    </span>
                                                    <div className="photoUpload-files fl-wrap" />
                                                    <div style={{ paddingTop: "27px" }}>
                                                        <span className="custom_image_button">
                                                            Select and upload
                                                        </span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className="photoUpload-files fl-wrap" />
                            </div>

                            <div
                                className="row"
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "flex-start",
                                }}
                            >
                                {imageList.map((image, index) => (
                                    <ImageCard
                                        key={index}
                                        image={image}
                                        index={index}
                                        moveImage={moveImage}
                                        onDelete={handleDelete}
                                        isFeatured={index === featuredIndex}
                                        onStarClick={handleStarClick}
                                        description={description}
                                        onDescriptionClick={handleDescriptionClick}
                                    />
                                ))}
                            </div>

                        </div>
                    )}
                </ImageUploading>
                {/* Modal for Description */}
                {/* <ImageDecriptionModal
                    saveDescription={saveDescription}
                    closeModal={closeModal}
                    selectedImage={selectedImage}
                    description={description}
                    isModalOpen={isModalOpen}
                    setDescription={setDescription} /> */}
                {isModalOpen &&

                    <ModalImage
                        saveDescription={saveDescription}
                        closeModal={closeModal}
                        selectedImage={selectedImage}
                        description={description}
                        isModalOpen={isModalOpen}
                        setDescription={setDescription} />
                }
            </div>

            {/* <div onClick={openModalCustom}>Open Modal</div> */}



        </>
    );
});

export default Images;
